import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { authorChanged, categoryChanged } from "../../redux/filter/action";

const Blog = ({ blog }) => {
  const filters = useSelector((state) => state.filters);
  const dispatch = useDispatch();
  const {
    blogName,
    blogImage,
    authorLogo,
    authorName,
    blogCategory,
    blogDate,
    readTime,
  } = blog;
  const { authorNames, blogCategories } = filters;

  const handleAuthorChange = (authorName) => {
    if (authorNames.includes(authorName)) {
      dispatch(authorChanged(authorName, "removed"));
    } else {
      dispatch(authorChanged(authorName, "added"));
    }
  };

  const handleBlogCategoriesChange = (category) => {
    if (blogCategories.includes(category)) {
      dispatch(categoryChanged(category, "removed"));
    } else {
      dispatch(categoryChanged(category, "added"));
    }
  };

  return (
    <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
      <div className="flex-shrink-0">
        <img className="h-48 w-full object-cover" src={blogImage} alt="" />
      </div>
      <div className="flex-1 bg-white p-6 flex flex-col justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-indigo-600">
            <span
              className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800"
              style={{ cursor: "pointer" }}
              onClick={() => handleBlogCategoriesChange(blogCategory)}
            >
              {blogCategory}
            </span>
          </p>
          <div className="block mt-1">
            <p className="text-xl font-semibold text-gray-900">{blogName}</p>
          </div>
        </div>
        <div className="mt-6 flex items-center">
          <div
            className="flex-shrink-0"
            style={{ cursor: "pointer" }}
            onClick={() => handleAuthorChange(authorName)}
          >
            <img className="h-10 w-10 rounded-full" src={authorLogo} alt="" />
          </div>
          <div className="ml-3">
            <p
              className="text-sm font-medium text-gray-900 hover:underline"
              style={{ cursor: "pointer" }}
              onClick={() => handleAuthorChange(authorName)}
            >
              {authorName}
            </p>
            <div className="flex space-x-1 text-sm text-gray-500">
              <time datetime="2020-03-16">{blogDate}</time>
              <span aria-hidden="true">&middot;</span>
              <span> {readTime} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
